import { VotingSessionIdType } from "../models/types";

export const VotingSessionLabel: { [k in VotingSessionIdType]: string } = {
  main: "votes",
  "playoff-1": "1st playoff",
  "playoff-2": "2nd playoff",
};
